import { Ref } from 'vue';
import { MaybeNull } from '@/shared/types';

const throwError = (): never => {
  throw Error(`Unable to get property value of template ref. Ref does not exists or is not mounted yet`);
};

export const getRefProperty = <T extends HTMLElement, K extends keyof T>(ref: Ref<MaybeNull<T>>, prop: K): T[K] => {
  if (!ref.value) {
    return throwError();
  }

  return ref.value[prop];
};

export const getSafeRef = <T extends HTMLElement>(ref: Ref<MaybeNull<T>>): T => {
  if (!ref.value) {
    return throwError();
  }

  return ref.value;
};
